import { render, staticRenderFns } from "./view-item.vue?vue&type=template&id=01b6e5e2&"
import script from "./view-item.vue?vue&type=script&lang=js&"
export * from "./view-item.vue?vue&type=script&lang=js&"
import style0 from "./view-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "view-item.vue"
export default component.exports